export const abbreviations = [
  'AK','AL','AR','AS','AZ','CA','CO','CT','DC','DE','FL','FM','GA','GU','HI',
  'IA','ID','IL','IN','KS','KY','LA','MA','MD','ME','MH','MI','MN','MO','MP',
  'MS','MT','NC','ND','NE','NH','NJ','NM','NV','NY','OH','OK','OR','PA','PR',
  'RI','SC','SD','TN','TX','UT','VA','VI','VT','WA','WI','WV','WY'
]